export default {"src":"/_next/static/media/kmd-logo-light.38c7c206.svg","height":36,"width":145,"blurWidth":0,"blurHeight":0};